import { render, staticRenderFns } from "./RoofSideSketch.vue?vue&type=template&id=50210d82"
import script from "./RoofSideSketch.vue?vue&type=script&lang=js"
export * from "./RoofSideSketch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports